import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from './events';

export function PageViewTracker() {
  const location = useLocation();
  const previousUrl = useRef(typeof document !== 'undefined' ? document.referrer : '');

  useEffect(() => {
    trackPageView(previousUrl.current);
    previousUrl.current = window.location.href;
  }, [location.pathname, location.search]);

  return null;
}
